let productTitle = getProductTitle()

document.addEventListener('initializeCustomVariantSelection', function() {
  triggerOptionClick()
})

triggerOptionClick = function() {
  if (productTitle){
    let optionSelection = sessionStorage.getItem(productTitle)
    if (optionSelection) {
      let optionsJson = JSON.parse(optionSelection)
      if (optionsJson && optionsJson.hasOwnProperty('options')){
        optionsJson['options'].forEach(function(option){
          if (option.hasOwnProperty('data-index') && option.hasOwnProperty('value')) {
            let elements = $(`input[data-index='${option['data-index']}'][value='${option['value']}']`)
            Array.from(elements).forEach(item => item.dispatchEvent(new PointerEvent('click', {'bubbles': true})))
          }
        })
      }
    }
  }
}

document.addEventListener('change', function(event){
  if (event.target.parentElement.classList.contains('variant-input-stub')){
    let skuElements = document.getElementsByClassName('product-single__sku')
    Array.from(skuElements).forEach(elem => elem.innerText = theme.strings.customOptionsStubTexts.sku)

    let priceElements = document.getElementsByClassName('product__price')
    Array.from(priceElements).forEach(elem => elem.innerText = theme.strings.customOptionsStubTexts.price)

    let policiesElements = document.getElementsByClassName('product__policies')
    Array.from(policiesElements).forEach(function(elem){
      Array.from(elem.children).forEach(child => child.innerText = theme.strings.customOptionsStubTexts.price_extra)
    })
  }

  let optionSelectionEntries = Array.from($('.variant-input-wrap input[type=radio]:checked')).map(item => ({"data-index": item.dataset['index'], "value": item.value}))
  let options = JSON.stringify({'options': optionSelectionEntries})
  sessionStorage.setItem(productTitle, options)
});

function getProductTitle(){
  let productTitle
  let productTitles = Array.from($("[id^='ProductSection']")).map(item => item.dataset['productTitle'])
  if(productTitles.length > 0) {
    productTitle = productTitles[0]
  }
  return productTitle
}
